// history is installed automatically as dependency with router-dom
import { createBrowserHistory } from "history";
export default createBrowserHistory();
